import {
    Form,
    Button,
    Select,
    Result,
    Input,
    Upload
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import {
    signularisApi,
    useCreateMetaDocumentMutation,
    useGetRecipientsListQuery
} from "../../../store/api/signularisApi";
import { useAppDispatch } from "../../../hooks/redux";
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import { InboxOutlined, SendOutlined } from "@ant-design/icons";
import Dragger from "antd/lib/upload/Dragger";
import { documentTemplates } from "../../../const";
import genDocument9 from "../misc/gendoc9";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import style from '../CreateDocument.module.scss';

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;

// Генерирует ID
let guid = () => {
    let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
    return s4() + s4() + s4() + s4();
}

// Форматирование даты
function styledDate() {
    const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", 
                    "августа", "сентября", "октября", "ноября", "декабря"]
    const dobj = new Date()
    return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

type DocumentTitle1 = 'Ректору ГГНТУ \nМинцаеву М. Ш.' | 'Проректору по АХЧ \nЧегарбиеву А.С.' | 'Проректору по ЦиИ Пашаеву М.Я.'
const documentTitle1: DocumentTitle1[] = ['Ректору ГГНТУ \nМинцаеву М. Ш.', 'Проректору по АХЧ \nЧегарбиеву А.С.', 'Проректору по ЦиИ Пашаеву М.Я.']

function Template() {
    const info = useSelector((state: RootState) => state.userinfo);
    const dispatch = useAppDispatch();
    const { data: recipientsList } = useGetRecipientsListQuery();
    const [form] = useForm();
    
    const [uploadFiles, setUploadFiles] = useState<any[]>([]);
    const [docname, setDocname] = useState("");
    const docTemplate: DocTemplateType = 'applicationForAhch';

    const [createMetaDocument, {
        isLoading: mutationLoading,
        isSuccess: mutationSuccess,
    }] = useCreateMetaDocumentMutation();

    const handleUpload = (info: any) => {
        setUploadFiles(info.fileList);
    };

    const onFinish = async (values: any) => {
        const regnum = guid();
        const templateName = documentTemplates[docTemplate] || "Заявка АХЧ";
        setDocname(templateName);

        const formData = new FormData();
        formData.append("title", `${templateName} №${regnum}`);
        formData.append("brief", "Сгенерировано из шаблона");
        formData.append("recipients", values.recipients.join(","));
        formData.append("documentType", docTemplate);

        // Добавляем все прикрепленные файлы
        uploadFiles.forEach((file) => {
            if (file.originFileObj) {
                formData.append("attachments", file.originFileObj, file.originFileObj.name);
            }
        });

        const templateValues = {
            ...values,
            regnum,
            regdate: styledDate()
        };

        const pdfBytes = await genDocument9(templateValues, info);
        formData.append("file", new Blob([pdfBytes]));
        
        createMetaDocument(formData);
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']));
    }

    if (mutationSuccess) return (
        <Result
            status="success"
            title="Заявка создана"
            subTitle={`Документ "${docname}" успешно зарегистрирован.`}
            extra={<Link to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}><Button type="primary">Создать еще</Button></Link>}
        />
    );

    return (
        <div className={style.generatorWrapper} >
            <h2 className={style.title}>{documentTemplates[docTemplate]}</h2>
            
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Item label="Получатели" name="recipients" rules={[{ required: true, message: 'Выберите получателей' }]}>
                    <Select mode="multiple" placeholder="Выберите сотрудников..." size="large"
                    allowClear
           filterOption={(input, option) =>
              (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
            }>
                        {recipientsList?.map((recipient) => (
                                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                                {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                                </Option>
                            ))}
                    </Select>
                </Item>

                <Item label="Заявка на имя" name="docTitle" rules={[{required: true, message: 'Выберите адресата'}]}>
                    <Select placeholder="Кому адресована заявка?" size="large">
                        {documentTitle1.map((title) => (
                            <Option key={title} value={title}>{title}</Option>
                        ))}
                    </Select>
                </Item>

                <Item label="Текст заявки" name="regtext" rules={[{ required: true, message: 'Заполните содержание' }]}>
                    <TextArea placeholder="Опишите необходимые работы..." rows={5}/>
                </Item>

                <Item label="Приложения (фото, сметы, пояснения)" name="file">
                    <Dragger
                        name="file"
                        multiple={true}
                        maxCount={10}
                        onChange={handleUpload}
                        style={{ borderRadius: 16, background: '#f8fafc', padding: '20px 0' }}
                    >
                        <p className={style.draggerIcon}><InboxOutlined /></p>
                        <p className="ant-upload-text">Кликните или перетащите файлы</p>
                        <p className="ant-upload-hint">Можно загрузить до 10 файлов</p>
                    </Dragger>
                </Item>

                <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={mutationLoading}
                    size="large"
                    icon={<SendOutlined style={{ display: 'inline-flex' }} />}
                    style={{ width: '100%', marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    Создать заявку
                </Button>
            </Form>
        </div>
    )
}

export default Template;
